import type { AxiosInstance, AxiosRequestConfig } from 'axios';
import type { z } from 'zod';
import { ApiError } from './api-error';

/**
 * Executa a requisição e valida a resposta com o schema de `@jaf/contracts` antes de
 * entregá-la à UI. Resposta fora do contrato vira ApiError do tipo `contract`.
 */
export async function requestJson<Schema extends z.ZodType>(
  client: AxiosInstance,
  schema: Schema,
  config: AxiosRequestConfig,
): Promise<z.output<Schema>> {
  const { data } = await client.request<unknown>(config);
  const parsed = schema.safeParse(data);
  if (!parsed.success) {
    throw new ApiError({ kind: 'contract', status: 0, title: 'Resposta inesperada do servidor' });
  }
  return parsed.data;
}
